// extracted by mini-css-extract-plugin
module.exports = {"row":"supply-row_row__1YVG8","buttonWrapper":"supply-row_buttonWrapper__fIcHV"};